import classNames from "classnames";
import styles from "./main.module.scss";
import line from "../../assets/badgeLine.png";
import avatar from "../../assets/user.png";
import { ReactComponent as BackArrow } from "../../assets/arrow-back.svg";
import { ReactComponent as Logo } from "../../assets/logo-small.svg";
import { ReactComponent as Phone } from "../../assets/phone.svg";
import { ReactComponent as Envelope } from "../../assets/envelope.svg";
import Button from "../../custom/button/button";
import { useAtomValue } from "jotai";
import { getUserGrade, userData, userProfile } from "../../state";
import { QRCode, Spin } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MemberType, getAllBadges } from "../../requests";
import { AxiosError } from "axios";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

const GateEntry = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const user = useAtomValue(userData);
  const profile = useAtomValue(userProfile);
  const grade = getUserGrade(user?.MembershipTypeId!);
  const eventDetailId = params.get("eventDetailId");
  const eventId = params.get("eventId");
  const eventType = params.get("eventType");
  const eventName = params.get("eventName");
  const badgeRef = useRef(null);
  const isCorporateMember = user?.MembershipTypeId === MemberType.Corporate;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["get-badges"],
    queryFn: () =>
      getAllBadges({
        MembershipNo: user?.MemberId!,
        EvenType: eventType!,
        IsCorporate: isCorporateMember,
        EventDetailsId: parseInt(eventDetailId!),
        EventId: parseInt(eventId!),
      }),
    enabled: !!eventDetailId && !!eventId && !!eventType,
  });

  const downloadBadge = useReactToPrint({
    content: () => badgeRef.current,
    documentTitle: "Gate Entry Badge",
  });

  const badge = data?.Data?.filter(
    (x) => x.EventName === eventName || x.EventName.includes(eventName!)
  ) as Badge[];

  if (isLoading)
    return <Spin style={{ justifySelf: "center", alignSelf: "center" }} />;
  if (isError) return <div>{(error as AxiosError)?.message}</div>;

  return (
    <div>
      <section className={styles.heading}>
        <div className={classNames("headingWithBackArrow")}>
          <button onClick={() => navigate(-1)}>
            <BackArrow />
          </button>
          <h3>Gate Entry Badge</h3>
        </div>
        <Button onClick={downloadBadge} text="Download" />
      </section>
      <br />
      <br />
      <div className={styles.list}>
        {badge &&
          badge.length > 0 &&
          badge?.map((item, index) => (
            <section ref={badgeRef} key={index} className={styles.badgeGroup}>
              <div className={styles.entryBadge}>
                <img src={line} alt="line" />
                <div className={styles.entryDetails}>
                  <Logo />
                  <br />
                  <img
                    src={profile?.UploadPictureUrl || avatar}
                    alt="profile"
                  />
                  <br />
                  {isCorporateMember ? (
                    <p>
                      <b>Member Name: {item.Name}</b>
                    </p>
                  ) : (
                    <>
                      <h3>{`${profile?.FirstName || ""} ${
                        profile?.MiddleName || ""
                      } ${profile?.LastName || ""}`}</h3>
                      <label>{grade} Grade Member</label>
                      <br />
                      <br />
                      <p>
                        <b>Member Name: {item.Name}</b>
                      </p>
                      <p>
                        <b>ID Number: </b>
                        {user?.MemberId}
                      </p>
                      <p>
                        <b>Mobile: </b>
                        {profile?.PhoneNumber}
                      </p>
                    </>
                  )}
                  <hr className={styles.badgeDivider} />
                  <br />
                  {isCorporateMember ? (
                    <p>Sponsored by: {item.OrganisationName}</p>
                  ) : (
                    <p>{profile?.Email}</p>
                  )}
                </div>
                <img src={line} alt="line" />
              </div>
              <div className={styles.entryBadge}>
                <img src={line} alt="line" />
                <div className={styles.entryDetails}>
                  <QRCode type="svg" value={item.GuidQrcode} />
                  <br />
                  <h3>CIPM Nigeria</h3>
                  <br />
                  <p>
                    Please send back the card to the address given below if
                    otherwise found.
                  </p>
                  <hr className={styles.badgeDivider} />
                  <Logo />
                  <span>
                    <Phone /> +234-7001-2375-55
                  </span>
                  <span>
                    <Envelope /> info@cipmnigeria.org
                  </span>
                  <br />
                  <p>
                    1 CIPM Avenue, Off Obafemi Awolowo Way, Opp. Lagos State
                    Secretariat, Alausa, Ikeja, Lagos
                  </p>
                </div>
                <img src={line} alt="line" />
              </div>
            </section>
          ))}
      </div>
    </div>
  );
};

export default GateEntry;
